module.exports = __webpack_public_path__ + "static/media/profile_icon.f84df715.png";